import React, { useState } from 'react';
import { Toast } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import { StatusToastType } from './types';

const StatusToast = ({
  IsFailed,
  Message,
  Title,
  DelayMs,
  IsAutohide,
}: StatusToastType) => {
  const [show, setShow] = useState<boolean>(true);
  const ToastIcon = IsFailed ? 'exclamation-diamond-fill' : 'check-circle-fill';
  const ToastColor = IsFailed ? 'danger' : 'success';
  return (
    <Toast
      autohide={IsAutohide ?? true}
      delay={DelayMs ?? 3000}
      className="shadow-lg"
      onClose={() => setShow(false)}
      show={show}
    >
      <Toast.Body className="px-24 py-16 position-relative">
        {/* Visible close button when autohide is disabled */}
        {IsAutohide === false && (
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-2"
            aria-label="Close"
            onClick={() => setShow(false)}
          />
        )}
        <div
          className={`statustoast-border position-absolute bg-${ToastColor}`}
        />
        <div className="d-flex align-items-center">
          <Icon Name={ToastIcon} CssClass={`h4 text-${ToastColor} me-24`} />
          <div className="flex-grow-1">
            <h5 className="h6 mb-4">{Title}</h5>
            <p className="body-small text-dark mb-0">{Message}</p>
          </div>
        </div>
      </Toast.Body>
    </Toast>
  );
};
export default StatusToast;
export { StatusToast };
